export default __webpack_public_path__ + "static/media/10.417c9088.jpg";